import Tippy from '@tippyjs/react';

import Icon from 'components/shared/Icon/Icon';
import RadioButton from 'components/shared/RadioButton/RadioButton';

const ImportTypeSelector = ({ importType, setImportType, importTypes }) => {
  const options = [
    {
      value: importTypes.ALL,
      label: 'All data',
      tooltip: 'Patients, services, macros, packages & products'
    },
    {
      value: importTypes.NONE,
      label: "I don't want to import anything"
    },
    {
      value: importTypes.SPECIFIC,
      label: 'Specific data'
    }
  ];

  return (
    <div className="flex flex-col gap-3">
      <span className="text-sm font-500 text-neutral-900">
        What type of data do you want to import?
      </span>
      <div className="flex gap-6 sm:flex-col sm:gap-2">
        {options.map((option) => (
          <div key={option.value} className="flex w-fit items-center gap-1">
            <RadioButton
              id={`import-type-${option.value}`}
              name="import-type"
              value={option.value}
              isSelected={importType === option.value}
              onChange={() => setImportType(option.value)}
              label={option.label}
              wrapperClassName="!w-auto radio--small"
            />
            {option.tooltip && (
              <Tippy content={option.tooltip} placement="right" className="tippy-dark">
                <div className="flex cursor-help items-center">
                  <Icon icon="info-mono" size={16} color="neutral" shade={700} />
                </div>
              </Tippy>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default ImportTypeSelector;
